import { FC } from 'react';
import { Center, useDisclosure } from '@chakra-ui/react';
import { Feature } from '@shinetools/pricing-plan-library';

import {
  isFetchingMore,
  isLoading,
  isSettingVariables,
} from 'common/graphql/networkStatus';
import { useCurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';
import useDebounce from 'common/hooks/useDebounce';
import SunshineLoader from 'components/_core/SunshineLoader';
import { CatalogItemCreateModal } from 'features/Work/components/CatalogItemModals';
import * as Layout from 'layouts/ContentLayout';

import { useCatalogItemsQuery } from '../../../../hooks/useCatalogItemsQuery';
import { useFilters } from '../../hooks/useFilters';
import Body from './components/Body';
import Filters from './components/Filters';
import Header from './components/Header';

const List: FC = () => {
  const { filters } = useFilters();
  const searchInput = useDebounce(filters?.q ?? '');

  const { isFeatureAvailable } = useCurrentPricingPlan();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { catalogItems, fetchMore, networkStatus, pageInfo } =
    useCatalogItemsQuery(searchInput ? { filters: { searchInput } } : {});

  const loading = isLoading(networkStatus) || isSettingVariables(networkStatus);
  const isItemsCatalogAvailable = isFeatureAvailable(
    Feature.InvoicingItemsCatalog,
  );

  return (
    <>
      <Layout.Root>
        <Layout.Body size="md">
          <Header onCreateItem={onOpen} />

          {isItemsCatalogAvailable ? <Filters /> : null}

          {loading ? (
            <Center paddingTop="space-128">
              <SunshineLoader />
            </Center>
          ) : (
            <Body
              catalogItems={catalogItems}
              isFetchingMore={isFetchingMore(networkStatus)}
              onCreateItem={onOpen}
              onFetchMore={fetchMore}
              pageInfo={pageInfo}
            />
          )}
        </Layout.Body>
      </Layout.Root>

      <CatalogItemCreateModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default List;
